import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { CONSTANTS_VALUE } from 'src/app/config/constants.module';
import { AppParameterService } from 'src/app/core/app-parameter/app-parameter.service';
import { MainMapService } from '../../shared/service/main-map.service';
import { WidgetNotifyService } from '../../shared/service/widget-notify.service';
import { WidgetService } from '../../shared/service/widget.service';
import { TranslateService } from '@ngx-translate/core';
import { TakeUntilDestroy } from '../../core/component/take-until-destroy';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'main-map',
    templateUrl: './main-map.component.html',
    standalone: false
})
export class MainMapComponent extends TakeUntilDestroy implements OnInit, AfterViewInit {
  @ViewChild('mainMap', { static: true }) mapElementRef: ElementRef;
  @ViewChild('dynamic', { read: ViewContainerRef, static: true }) mapContainerRef: ViewContainerRef;

  cursor = 'default';

  constructor(
    private mainMapService: MainMapService,
    private widgetService: WidgetService,
    private appParameterService: AppParameterService,
    private widgetNotifyService: WidgetNotifyService,
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    // set map-view to DOM
    const mapView: __esri.MapView = this.mainMapService.mapView;
    mapView.container = this.mapElementRef.nativeElement;
    // Referenziert das DOM mapElementRef als root container für dynamischen Widget Erstellung
    this.widgetService.setRootViewContainerRef(this.mapContainerRef);
    // load all saved widgets
    this.widgetService.loadWidgetsFromLocalStorage();

    // Referenziert das DOM mapElementRef als root container für PopupService
    this.mainMapService.setRootViewContainerRef(this.mapContainerRef);
    this.handleUrlParameters();

    this.mainMapService.cursor$.pipe(takeUntil(this.unsubscribe$)).subscribe(currentCursor => {
      this.cursor = currentCursor;
      this.cdr.detectChanges();
    });
    this.mainMapService.mapView.when(() => {
      this.updateZoomButtonTitles();
    });
  }

  ngAfterViewInit(): void {
    this.mainMapService.mapView.on('layerview-create', event => {
      this.widgetNotifyService.onComponentDestroySubject.next(true);
    });
  }

  updateZoomButtonTitles() {
    setTimeout(() => {
      const zoomInButton = document.querySelector('.esri-zoom .esri-widget--button[title="Vergrößern"]') as HTMLElement;
      const zoomOutButton = document.querySelector('.esri-zoom .esri-widget--button[title="Verkleinern"]') as HTMLElement;
      const compassButton = document.querySelector('.esri-compass__icon-container[title="Kartenausrichtung zurücksetzen"]') as HTMLElement;

      if (zoomInButton) {
        zoomInButton.setAttribute('title', this.translateService.instant('WIDGET.ZOOM.IN'));
      }
      if (zoomOutButton) {
        zoomOutButton.setAttribute('title', this.translateService.instant('WIDGET.ZOOM.OUT'));
      }
      if (compassButton) {
        compassButton.setAttribute('title', this.translateService.instant('WIDGET.ZOOM.COMPASS'));
      }
    }, 500); // Pequeño delay para asegurarse de que los botones estén disponibles
  }

  /* Private methods
  ==========================  */

  private handleUrlParameters() {
    const functionName = this.router.parseUrl(this.router.url).queryParams[
      CONSTANTS_VALUE.APP_URL_PARAMS.PARAMETER_NAMES.FUNCTION
      ];
    if (functionName)
      this.appParameterService.handleAppParameter(functionName, this.router.parseUrl(this.router.url).queryParams);
  }

}
